import { createSelector } from 'reselect';
import {
  selectLocationBrandName,
  selectLocationBranchCode,
} from 'containers/PrimoAccount/selectors';

export const selectBrand = () =>
  createSelector(selectLocationBrandName(), (brand) => brand);

/**
 * FIXME this probably should be moved to a folder more aligned
 * with location or branches specifically.
 */
export const selectBranch = () =>
  createSelector(selectLocationBranchCode(), (branch) => branch);
